import React from "react";
import DOMPurify from "dompurify";
import { toVideoEmbedUrl } from "pages/PlatformAdmin/FeatureOfTheWeek/featureOfTheWeek.utils";

/**
 * Shared Feature of the Week card used on the live dashboard and admin preview.
 */
const FeatureOfTheWeekCard = ({
  title = "Feature of the Week",
  description = "",
  videoUrl = "",
  embedUrl = null,
  emptyMessage = null,
  className = "",
}) => {
  const resolvedEmbedUrl = embedUrl || toVideoEmbedUrl(videoUrl);
  const hasContent = Boolean(
    (description && description.trim()) || resolvedEmbedUrl
  );

  if (!hasContent) {
    if (!emptyMessage) {
      return null;
    }

    return (
      <div
        className={`rounded-lg border border-dashed border-gray-200 bg-gray-50 p-4 text-center text-sm text-gray-500 ${className}`}
      >
        {emptyMessage}
      </div>
    );
  }

  return (
    <div
      className={`feature-of-the-week-card overflow-hidden rounded-lg border border-indigo-100 bg-gradient-to-br from-indigo-50 via-white to-white shadow-sm ${className}`}
    >
      <div className="border-b border-indigo-100 bg-indigo-50/80 px-4 py-3">
        <p className="text-xs font-semibold uppercase tracking-wide text-indigo-600">
          Feature of the Week
        </p>
        {title ? (
          <h3 className="mt-1 text-base font-semibold text-gray-900">{title}</h3>
        ) : null}
      </div>

      <div className="space-y-3 p-4">
        {description ? (
          <div
            className="description-content-system-news text-sm text-gray-600"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(description, {
                ALLOWED_ATTR: ["target", "href", "rel"],
              }),
            }}
          />
        ) : null}

        {resolvedEmbedUrl ? (
          <div className="overflow-hidden rounded-md border border-gray-200 bg-black/5">
            <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
              <iframe
                title={title || "Feature of the Week video"}
                src={resolvedEmbedUrl}
                className="absolute inset-0 h-full w-full"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                allowFullScreen
              />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default FeatureOfTheWeekCard;
